module.exports = __webpack_public_path__ + "img/bg05.88f0b21c.gif";